import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Routes any authenticated user with `password_must_change=true` to
 * `/account/password` until they reset it. The reset endpoint clears the
 * flag + rotates the JWT, after which this guard becomes a no-op.
 *
 * The login page itself and the change-password page are exempt so the
 * user has somewhere to land.
 */
export default function PasswordMustChangeGate({ children }) {
    const { user, loading } = useAuth();
    const { pathname } = useLocation();

    if (loading) return children;
    if (!user || !user.password_must_change) return children;

    const exempt = pathname === "/account/password" || pathname === "/login";
    if (exempt) return children;

    return <Navigate to="/account/password" replace />;
}
